<template>
  <md-card>
    <md-card-header data-background-color="green">
      <h4 class="title">Avaliação do Atendimento</h4>
    </md-card-header>
    <md-card-content>
      <div class="card-content">
        <star-rating
          v-model="rating"
          :increment="1"
          :max-rating="5"
          :read-only="!!techRating"
        />

        <div v-if="showEvaluationOptions">
          <div v-if="showCommentInput">
            <md-field maxlength="5">
              <label>Comentário</label>
              <md-textarea v-model="evaluationComment" />
            </md-field>
          </div>

          <div v-if="showButtons">
            <md-button class="md-raised md-accent" @click="deny()">
              REJEITAR SOLUÇÃO
            </md-button>
            <md-button class="md-raised md-success" @click="approve()">
              APROVAR CHAMADO
            </md-button>
          </div>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>

<script>
export default {
  name: "TicketServiceEvaluation",
  props: {
    techRating: {
      type: Number,
      default: () => 0,
    },
    showEvaluationOptions: {
      type: Boolean,
      default: () => true,
    },
    showCommentInput: {
      type: Boolean,
      default: () => true,
    },
    showButtons: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      rating: this.techRating,
      evaluationComment: "",
    };
  },
  methods: {
    approve() {
      this.$emit("approve", this.rating, this.evaluationComment);
    },
    deny() {
      this.$emit("deny", this.rating, this.evaluationComment);
    },
  },
};
</script>

<style>
.card-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
